import React from 'react';
import PropTypes from 'prop-types';

import { PAGES } from '_constants';
import { licensePropType } from '_utils/licenses';

import LineItem from '_views/lineItem';

const LicenseResellerInfo = ({
  license,
  setNavigation
}) => {

  const onGoToReseller = () => setNavigation({ pageName: PAGES.RESELLERS, ids: [license.reseller._id] });

  return (
    <div>
      <LineItem label='Name' text={ license.reseller.name } onClick={ onGoToReseller } />
      <LineItem label='Status' text={ license.reseller.status } />
      <LineItem label='ID' text={ license.reseller._id } />
    </div>
  );
};

LicenseResellerInfo.propTypes = {
  license: licensePropType.isRequired,
  setNavigation: PropTypes.func.isRequired
};

export default LicenseResellerInfo;



// WEBPACK FOOTER //
// ./webAdmin/views/license/reseller.js